<template>
  <div class="edge-auditor__wrapper" v-if="sessionURL">
    <div class="edge-auditor__content">
      <iframe id="edge-auditor__iframe" :src="sessionURL" title="Edge Auditor"></iframe>
    </div>
  </div>
</template>
<script lang="ts">
import { Action, Getter, Mutation } from 'vuex-class'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { WaiverRequestData, EdgeAuditorSessionData } from '../interfaces/edge-auditor-interface'
import SigningData from '../interfaces/SigningData'
import ApiService from '../../Api/services/ApiService'

@Component({
  components: {
  },
})
class EdgeAuditorWaiver extends Vue {
  @Prop({ required: true, default: null }) edgeAuditorData: any

  @Mutation('setPageLoading') setPageLoading

  public sessionURL: string | null = null
  public edgeAuditorBaseUrl: string = 'edgeauditor.com'
  public signerName: string | null = null


  public mounted() {
    this.setPageLoading(true)
    this.initListener()
    this.initializeEdgeAuditorSessionURL()
  }

  public unmounted() {
    this.destroy()
  }

  public destroy() {
    this.sessionURL = null
    this.removeListener()
  }

  public initListener() {
    window.addEventListener('message', this.handleMessageEvent, false)
  }

  public removeListener() {
    window.removeEventListener('message', this.handleMessageEvent, false)
  }

  public handleMessageEvent(event: MessageEvent) {
    const message = event.data
    if (!event.origin.includes(this.edgeAuditorBaseUrl)) {
      return
    }
    switch (message.messageType) {
      case 'waiversLoaded':
        this.setPageLoading(false)
        break
      case 'waiverCompleted':
        const edgeAuditorSigningData: SigningData = {
          signature: '',
          agree: true,
          signerName: this.signerName,
          waiverHTML: '',
          externalWaiverUrl: message.data?.completedWaiverLink
        }
        this.$emit('save-signature', edgeAuditorSigningData)
        break
      case 'allWaiversCompleted':
        this.setPageLoading(false)
        break
      case 'error':
        console.error('EDGE Auditor waiver error: ', message.reason)
        break
    }
  }

  public async initializeEdgeAuditorSessionURL(): Promise<void> {
    try {
      const url = await this.getEdgeAuditorSessionURL()
      this.sessionURL = url
    } catch (error) {
      this.setPageLoading(false)
    }
  }

  /**
   * Gets the Edge Auditor session URL
   * @returns {Promise<string>} The session URL
   * @throws {Error} When the request fails or returns an error
   */
  public async getEdgeAuditorSessionURL(): Promise<string> {
    try {
      const data: any = await ApiService.GetEdgeAuditorSesion(this.edgeAuditorData as WaiverRequestData)
      if (data) {
        return data as string
      } else {
        throw new Error('No URL received from Edge Auditor service')
      }
    } catch (error) {
      throw new Error('Error getting Edge Auditor session URL: ' + error.message)
    }
  }
}
export default EdgeAuditorWaiver
</script>

<style lang="scss" scoped>
.edge-auditor__content {
  width: 100%;
  height: 97vh;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>